module.exports = __webpack_public_path__ + "img/aviso.197bcc73.svg";